import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        currentPrice: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },
        listPrice: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
        },
        suggested: {
            textStyle: 'body-xsmall',
            color: 'foreground.neutral.subtle',
        },
        discount: {
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
            fontWeight: 'normal',
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
        priceBoxIva: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: {base: 'xxsmall.base', md: 'xxsmall.md', lg: 'xxsmall.lg', xl: 'xxsmall.xl'},
        },
        priceOmniVatContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: {
                base: 'xxxsmall-1.base',
                md: 'xxxsmall-1.md',
                lg: 'xxxsmall-1.lg',
                xl: 'xxxsmall-1.xl',
            },
        },
        priceBox: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(10),
        },
        button: {
            display: 'flex',
            height: remCalc(40),
            minWidth: [remCalc(226), remCalc(226), remCalc(140), remCalc(140)],
            maxHeight: remCalc(40),
            padding: `${remCalc(18)} ${remCalc(22)}`,
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(10),
            alignSelf: 'stretch',
            variant: 'primary',
            textStyle: 'body-medium',
            letterSpacing: remCalc(0.4),
            textAlign: 'center',
            fontWeight: 'bold',
        },
        infoIcon: {
            boxSize: remCalc(16),
            color: 'foreground.neutral.subtle',
            cursor: 'pointer',
        },
        energyLabel: {
            pt: remCalc(4),
        },
        energyLabelContent: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            gap: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            '& > *': {
                alignSelf: 'center',
            },
        },
    },
    variants: {
        sticky: {
            currentPrice: {
                textStyle: 'body-small',
                fontWeight: 'normal',
                color: 'foreground.neutral.default',
            },
            listPrice: {
                textStyle: 'body-small',
                fontWeight: 'normal',
                color: 'foreground.neutral.subtle',
            },
            suggested: {
                textStyle: 'body-small',
                color: 'foreground.neutral.subtle',
            },
            discount: {
                textStyle: 'body-small',
                color: 'foreground.neutral.subtle',
            },
        },
        pdpSelectorDrawerCard: {
            currentPrice: {
                textStyle: 'body-small',
                fontWeight: 'medium',
            },
            discount: {
                textStyle: 'body-small',
                fontWight: 'normal',
            },
            listPrice: {
                textStyle: 'body-small',
                fontWight: 'normal',
            },
            suggested: {
                textStyle: 'body-small',
                fontWight: 'normal',
            },
            infoIcon: {
                boxSize: remCalc(12),
            },
        },
        pdpSelectorCurrentVariant: {
            currentPrice: {
                textStyle: 'body-small',
                fontWeight: 'medium',
            },
            discount: {
                textStyle: 'body-small',
            },
            listPrice: {
                textStyle: 'body-small',
            },
            infoIcon: {
                boxSize: remCalc(12),
            },
        },
        warrantyPlan: {
            currentPrice: {
                textStyle: 'body-small',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
            },
            listPrice: {
                textStyle: 'body-xsmall',
                color: 'foreground.neutral.subtle',
            },
            discount: {
                textStyle: 'body-xsmall',
                color: 'foreground.neutral.subtle',
            },
        },
        productUpgrade: {
            container: {
                gap: 0,
            },
            priceBoxIva: {
                gap: remCalc(2),
            },
            priceBox: {
                gap: remCalc(8),
            },
            currentPrice: {
                textStyle: 'body-small',
                fontWeight: 'medium',
                color: 'foreground.neutral.default',
            },
            listPrice: {
                textStyle: 'body-small',
                color: 'foreground.neutral.subtle',
                textDecoration: 'line-through',
            },
            suggested: {
                textStyle: 'body-small',
                color: 'foreground.neutral.subtle',
            },
            discount: {
                textStyle: 'body-small',
                color: 'foreground.neutral.subtle',
            },
            infoIcon: {
                boxSize: remCalc(12),
            },
        },
    },
}
